import { render, staticRenderFns } from "./SportsModule.vue?vue&type=template&id=63767efb&scoped=true"
import script from "./SportsModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportsModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportsModule.vue?vue&type=style&index=0&id=63767efb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63767efb",
  null
  
)

export default component.exports